import React, { useEffect, useMemo, useRef, useState } from "react";
import { useVeltClient } from "../context";
export function usePresenceUtils() {
    var _a = React.useState(), presenceElement = _a[0], setPresenceElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || presenceElement)
            return;
        var loadedPresenceElement = client.getPresenceElement();
        setPresenceElement(loadedPresenceElement);
    }, [client, setPresenceElement, presenceElement]);
    return presenceElement;
}
/**
 * @deprecated Use `usePresenceData` hook instead.
 */
export function usePresenceUsers() {
    var presenceElement = usePresenceUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!presenceElement)
            return;
        var subscription = presenceElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [presenceElement]);
    return data;
}
export function usePresenceData(query) {
    var presenceElement = usePresenceUtils();
    var _a = useState({ data: null }), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef();
    // Memoize the inputs
    var memoizedData = useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(presenceElement === null || presenceElement === void 0 ? void 0 : presenceElement.getData))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = presenceElement.getData(memoizedData)
            .subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData({ data: null });
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [presenceElement === null || presenceElement === void 0 ? void 0 : presenceElement.getData, memoizedData]);
    return data;
}
